import api from "../api";
import {ElMessage} from "element-plus";

export default {
    namespaced: true,
    state: {
        ticket_categories: {data: [], current_page: 1, total: 0, per_page: 10},
        errors: {
            data: {
                errors: {}
            }
        },
        has_errors: false,
        loading: false,
        dialogVisible: false,
    },
    getters: {
        dialogVisible: state => state.dialogVisible,
        loading: state => state.loading,
        ticket_categories: state => state.ticket_categories,
        errors: state => state.errors,
        has_errors: state => state.has_errors,
    },
    mutations: {
        setDialogVisible(state, status) {
            state.dialogVisible = status;
        },
        setLoading(state, data) {
            state.loading = data;
        },
        setTicketCategories(state, data) {
            state.ticket_categories = data;
        },
        setErrors(state, errors) {
            state.errors = errors
        },
        hasErrors(state, val) {
            state.has_errors = val
            if (!val) {
                state.errors = {
                    data: {
                        errors: {}
                    }
                };
            }
        }
    },
    actions: {
        openDialogVisible({commit}, status) {
            commit('setDialogVisible', status);
        },
        async getTicketCategories({commit}, filters) {
            commit('setLoading', true);
            try {
                const response = await api.getTicketCategories(filters);
                commit('setTicketCategories', response);
                commit('setLoading', false);
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

        async createTicketCategories({dispatch, commit}, data) {
            try {
                commit('hasErrors', false)
                await api.createTicketCategories(data);
                ElMessage.success('ticket category created successfully!');
                commit('setDialogVisible', false)
                dispatch('getTicketCategories', {
                    paginate: true
                })
            } catch (e) {
                commit('hasErrors', true)
                commit('setErrors', e.response)
                ElMessage.error('Error creating ticket category!');
            }
        },
        async editTicketCategories({dispatch, commit}, data) {
            try {
                await api.editTicketCategory(data);
                ElMessage.success('ticket category updated successfully!');
                commit('setDialogVisible', false)
                dispatch('getTicketCategories', {
                    paginate: true
                })
            } catch (e) {
                ElMessage.error('Error updating ticket category');
            }
        },
        async deleteTicketCategories({commit, dispatch}, data) {
            commit('setLoading', true);
            try {
                const response = await api.deleteTicketCategory(data);
                commit('setLoading', false);
                dispatch('getTicketCategories', {
                    paginate: true
                })
                if (response.status === 401) {
                    ElMessage.warning({
                        message: response.message,
                        duration: 10000
                    });
                } else {
                    ElMessage.success({
                        message: response.message,
                        duration: 10000
                    });
                }
            } catch (e) {
                ElMessage.error(e.response.data.message);
                commit('setLoading', false);
            }
        },

    }
}
